// extracted by mini-css-extract-plugin
export default {"unsubscribedChip__container":"style-module__unsubscribedChip__container___L91oS"};